<template>
    <el-dialog
        fullscreen
        append-to-body
        lock-scroll
        :title="title"
        :visible.sync="dialogVisible">
        <div v-html="aggrementHtml" align="left"></div>
    </el-dialog>
</template>

<script>
    const axios = require('axios');
    import {GlobalLoading} from "../../utils";

    export default {
        name: "ShowAggrement",

        data(){
            return {
                dialogVisible: false,
                title: null,
                aggrementHtml: '协议内容正在加载中，请稍后.....',
            }
        },

        mounted(){
            // 记录一个坑如下，使用 vebview 无法关闭...
            // this.w = plus.webview.create('https://huocool.kufan.site/aggrements/privacy-aggrement.html', '', {top:'100px', bottom:'0px', mask: 'none'});
            // this.w.show();
        },

        methods: {
            show(url) {
                this.reset();
                this.dialogVisible = true;
                GlobalLoading.start();
                (async()=>{
                    try {
                        let r = await axios.get(url);
                        // console.log(r.data);
                        this.aggrementHtml = r.data;
                    } catch(error){
                        console.error(error);
                    } finally {
                        GlobalLoading.stop();
                    }
                })();
            },
            reset(){
                this.aggrementHtml = '协议内容正在加载中，请稍后.....';
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/ShowAggrement.vue